/// <reference path="../../_Ext/Editors/BOMGridEditor.ts" />

namespace TabAurous.ECommerce {
    import fld = ECommSalesItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ECommSalesItemsBOMEditor extends _Ext.BOMGridEditor<ECommSalesItemsBOMRow> { 
        protected getDialogType() { return ECommSalesItemsBOMDialog; }
        protected getLocalTextPrefix() { return ECommSalesItemsBOMRow.localTextPrefix; } 
        public ECommExchangeRate: number;
        public TransDate: Date;

        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommSalesItemsDialog).CalculateTotals();
                }
            });
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        } 
    }
}